export default __webpack_public_path__ + "static/media/bike.e36d11ae.png";